import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import {
   SystemLogsAreaOption,
   SystemLogsSeverityOption,
   SystemLogsTypeOption,
} from '../../models/system-log-filter-option';
import { SystemLogPrivileges } from '../../models/system-log-privileges';
import { SystemLogOrderingOptions, SystemLogRegisterOptions } from '../../models/system-log-register-options';
import { LogRegisterListItem } from '../../models/system-log-register-results.model';
import { selectQuickFilters } from '../../state/system-log-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-log-register-view',
    styleUrls: ['./account-log-register-view.component.scss'],
    templateUrl: './account-log-register-view.component.html',
    standalone: false
})
export class AccountLogRegisterViewComponent extends EntityRegisterView<
   LogRegisterListItem,
   SystemLogRegisterOptions,
   SystemLogOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => SystemLogRegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() systemLogPrivileges: SystemLogPrivileges;

   @Input() accountId: number | null;

   @Output() openDialog = new EventEmitter<{ callLogs: any }>();

   @Output() openLogDialog = new EventEmitter<{ callLogs: any }>();

   selectedSeverityType: SystemLogsSeverityOption | undefined = undefined;

   selectedSystemLogType: SystemLogsTypeOption | undefined = undefined;

   selectedSystemLogArea: SystemLogsAreaOption | undefined = undefined;

   getRouterLink(id: number): string {
      return `/system-log-register/${id}`;
   }

   onSeverityTypeSelected(severityOption: SystemLogsSeverityOption) {
      this.registerOptions = { ...this.registerOptions, severity: severityOption };
      this.quickFilterChange.emit(this.registerOptions);
   }

   onSystemLogTypeSelected(typeOption: SystemLogsTypeOption) {
      this.registerOptions = { ...this.registerOptions, systemLogType: typeOption };
      this.quickFilterChange.emit(this.registerOptions);
   }

   onSystemLogAreaSelected(areaOption: SystemLogsAreaOption) {
      this.registerOptions = { ...this.registerOptions, systemLogArea: areaOption };
      this.quickFilterChange.emit(this.registerOptions);
   }

   onOpenDialog(callLogs: any) {
      this.openDialog.emit({ callLogs: callLogs });
   }

   onOpenLogDialog(callLogs: any) {
      this.openLogDialog.emit({ callLogs: callLogs });
   }
}
